module.exports = __webpack_public_path__ + "static/img/network_widgrt_3.35a85bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/network_widgrt_3.png
// module id = EWfY
// module chunks = 11